import { Alert } from '@mui/material';
import { Interpolation } from '../../config/i18n/components/Interpolation';
import { Translation, Resources } from '../../@types/i18next';

type Props = {
  helpText: Translation<Resources>;
  href: string;
  fullWidth?: boolean;
};

export const DocsAlert = ({ helpText, href, fullWidth = false }: Props) => {
  const alertProps = fullWidth ? { sx: { justifyContent: 'center', width: 1, borderRadius: 0, textAlign: 'center' }, icon: false } : {};
  return (
    <Alert severity="info" {...alertProps}>
      <Interpolation i18nKey={helpText} variant="body2" items={[{ name: 'docs', href }]} />
    </Alert>
  );
};
